import { useQuery } from '@tanstack/react-query'

import { APIInstance } from '@/utils/functions/instance'
import { IApiBaseTypes } from '@/types/query-api'
import { IResponseType } from '@/types/response-type'

import { IGetInfoResponse } from './type'

export function useGetInfo({ disableToast, ...rest }: IApiBaseTypes<{}> = {}) {
  return useQuery({
    queryFn: async () =>
      await APIInstance<IGetInfoResponse>({
        url: 'mrf/personal-info',
        method: 'get'
      }),
    queryKey: ['uploadInfoDocument'],
    select: (data) => data.data,
    retry: 0,
    ...rest
  })
}
